import { memo } from 'react';
import { Box, FelaCSS } from '@bridebook/ui';
import componentStyles from './similar-venues-carousel.style';
import SimilarVenueCard from './similar-venue-card/similar-venue-card';
import { useTranslation } from 'next-i18next';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { getSearchList } from '@bridebook/web/app-basic/lib/search/selectors';
import { getSupplier } from '@bridebook/web/app-basic/lib/supplier/selectors';
import CarouselSimple from '@bridebook/ui/src/components/bbcommon/carousel-simple/carousel-simple';
import { getIsMobile, getIsTablet } from '@bridebook/web/app-basic/lib/app/selectors';
import mergeStyles from '@bridebook/ui/src/fela-utils/merge-styles';

interface IProps {
  styleOverrides?: {
    title?: FelaCSS;
    slide?: FelaCSS;
  };
}

const SimilarVenueCarousel = ({ styleOverrides }: IProps) => {
  const { t } = useTranslation();
  const styles = componentStyles();
  const currentSupplier = useSelector(getSupplier);
  const isMobile = useSelector(getIsMobile);
  const isTablet = useSelector(getIsTablet);

  const list = useSelector(getSearchList).filter((item) => item.id !== currentSupplier?.id);

  if (!list || !list.length) return null;

  return (
    <Box style={styles.wrapper}>
      <CarouselSimple
        carouselTitle={
          <Box as="h5" style={mergeStyles([styles.title, styleOverrides?.title || {}])}>
            {t('weThinkYouWillLove')}
          </Box>
        }
        noSSR={false}
        slideStyles={mergeStyles([styles.slide, styleOverrides?.slide || {}])}
        show={4}
        fixedWidthSlideMobile={304}
        noPaddingLeft
        isMobile={isMobile}
        isTablet={isTablet}
        slides={list.map((item) => (
          <SimilarVenueCard key={item.id} supplier={item} />
        ))}
      />
    </Box>
  );
};

export default memo(SimilarVenueCarousel);
